import React, { useState } from 'react';
import { Form, Input, Button, Row, Col, Card } from 'antd';
import { GlobalApiErrorHandler } from '../../shared/helpers';
import { InputBox, isBrowser, MsgBox } from '../../shared/custom-ant-d'
import { reqPostSavePasswordResetRequest } from '../../axios/api'

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

export const ForgotPassword = (props) => {
  const [loadSubmit, setLoadSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [form] = Form.useForm();

  const onFinish = (values) => {
    var jsonData = { PersonalEmail: values.email };
    var jsonStr = JSON.stringify(jsonData);
    setLoadSubmit(true);

    reqPostSavePasswordResetRequest(jsonStr)
      .then(res => {
        if (res.data.isSuccess) {
          MsgBox({
            type: 'success',
            message: 'We have sent you an email.',
            description: res.data.errorMessage,
          })
        } else {
          setErrorMessage(res.data.errorMessage);
        }
        form.resetFields();
        setLoadSubmit(false);

        props.history.push("/login");
      })
      .catch(err => {
        console.log(err);
        setLoadSubmit(false);
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      });

  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <>
      <Row justify="center">
        <Col sm={12}>
          <Card title="Forgot Password" className="iqor-header">
            <Form
              form={form}
              {...layout}
              name="login"
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                label="Email"
                name="email"
                rules={[
                  {
                    required: true,
                    message: 'Please fill in your email!',
                  },
                  {
                    type: "email",
                    message: "Please input a valid email"
                  }
                ]}
              >
                {
                  (isBrowser) ?
                    (<Input />) :
                    (<InputBox type={'email'} />)
                }
              </Form.Item>

              {
                errorMessage && (
                  <>
                    <Row className="force-error-message">
                      <Col md={{ span: layout.wrapperCol.span, offset: layout.labelCol.span }} xs={24}>
                        <div className="ant-form-item-explain ant-form-item-explain-error">
                          <div role="alert">{errorMessage}</div>
                        </div>
                      </Col>
                    </Row>
                  </>
                )
              }

              <Form.Item {...tailLayout}>
                <Button type="danger" htmlType="submit" loading={loadSubmit}>
                  Submit
                </Button> {" "}
                <Button type="default" htmlType="button" onClick={e => props.history.push("/login")}>
                  Cancel
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </>
  );
};
